// This file should contain all endpoints
// export const BASE_URL = 'https://flow-server-835771791858.northamerica-northeast1.run.app/api'; // Production
export const BASE_URL = 'https://flow.softquantum.net/api';
// export const TIDE_DATA_ENDPOINT = `${BASE_URL}/tide_data`;
// export const GOOGLE_API_KEY = 'AIzaSyCVW0_qwxy4pM1bmGHwywyjH0CohMowK4s';
